// extracted by mini-css-extract-plugin
module.exports = {"root":"googleReCaptcha_root__K1XrP mt-4"};